<template>
  <section>
    <el-dialog title="添加打包组合商品" :visible.sync="visible" width="70%">
      <div class="mod-block">
        <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
          <div class="groups">
            <el-form-item label="商品编码" prop="childItem" required :rules="[{validator: $validate.required}]">
              <mc-remote-select-opt
                v-model="form.childItem"
                listKey="result"
                valueKey="itemId"
                labelKey="itemId,itemDesc"
                query="itemId"
                url="/commoditymanagement/itemMaster/itemMasterList"
                :ajaxData="{pageSize: 5}"
                clearable
                 v-if="!isEdit"
                 @change="handleCode"
                >
              </mc-remote-select-opt>
              <span v-else>{{form.childItem}}</span>
            </el-form-item>
            <el-form-item label="商品名称" prop="childItemDesc">
              <el-input v-model="form.childItemDesc" disabled></el-input>
            </el-form-item>
            <el-form-item label="数量" prop="childItemNum" required :rules="[{validator: $validate.required}, {validator: $validate.positiveFloat, message: '请输入数字'}]">
              <el-input v-model="form.childItemNum" type="number"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
  export default {
    inject: ['getComData'],
    data () {
      return {
        isEdit: false,
        loading: false,
        visible: false,
        formCache: '',
        form: {
          childItem: null, // 商品编码
          childItemDesc: '', // 商品名称
          childItemNum: '', // 商品数量
        }
      }
    },
    watch: {
      visible () {
        if (this.visible) {
          this.resetForm(!this.isEdit)
        }
      }
    },
    computed: {
      isSimple () {
        return this.getComData().typeId == '2'
      }
    },
    methods: {
      edit (obj) {
        this.isEdit = true
        Object.assign(this.form, obj)
        this.visible = true
      },
      handleCode (data) {
        this.form.childItemDesc = data.itemDesc
      },
      save () {
        this.$refs.form.validate(async valid => {
          if (valid) {
            // 简单商品需校验是否建立组合关系
            if (this.isSimple) {
              this.loading = true
              let data = await this.$ajax.post('/commodityarchives/appItemQuery/selectSimpleItemSub', {
                childItem: this.form.childItem,
                childItemNum: this.form.childItemNum
                // subItem: this.form.childItem,
                // __isRP: false
              })
              this.loading = false
              if (data.code === 500) {
                this.$message.error('打包商品已存在简单组合关系，不允许重复添加!')
                return
              }
              this.$emit('sure', {...this.form})
              this.visible = false
            } else {
              this.$emit('sure', {...this.form})
              if (this.isEdit) {
                this.visible = false
              } else {
                this.resetForm(true)
              }
            }
          }
        })
      },
      resetForm (isCreate) {
        if (isCreate) {
          this.form = JSON.parse(this.formCache)
        }
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      }
    },
    mounted () {
      this.formCache = JSON.stringify(this.form)
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 0px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
    .groups {
      overflow: hidden;
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/complex-combine/combination-products-add.vue